import { render } from "./textAnswer.vue?vue&type=template&id=4d09d2c6&scoped=true"
import script from "./textAnswer.vue?vue&type=script&lang=js"
export * from "./textAnswer.vue?vue&type=script&lang=js"

import "./textAnswer.vue?vue&type=style&index=0&id=4d09d2c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d09d2c6"]])

export default __exports__